import { render, staticRenderFns } from "./stories_button.vue?vue&type=template&id=73dc12c0&"
import script from "./stories_button.vue?vue&type=script&lang=js&"
export * from "./stories_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports